// src/app/slices/fanSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  FanState,
  IFan,
  IFanIsolatorsSpringParams,
  IFanMotorBaseParams,
  IFanParams,
  IFanSpacings,
} from '../models';

const initialState: FanState = {
  fans: {},
  fan_params: null,
  fan_motor_base_params: null,
  fan_isolators_spring_params: null,
  fan_spacings: {
    top_btm: [],
    sides: [],
  },
};

const fanSlice = createSlice({
  name: 'fan',
  initialState,
  reducers: {
    setFan: (state, action: PayloadAction<IFan>) => {
      state.fans[action.payload.id] = {
        ...action.payload,
        params: action.payload.fan_params
          ? JSON.parse(action.payload.fan_params)
          : {},
        motorParams: action.payload.motor_params
          ? JSON.parse(action.payload.motor_params)
          : {},
        motorBaseParams: action.payload.motor_base_params
          ? JSON.parse(action.payload.motor_base_params)
          : {},
        siParams: action.payload.si_params
          ? JSON.parse(action.payload.si_params)
          : {},
      };
    },
    setFanParams: (state, action: PayloadAction<IFanParams | null>) => {
      state.fan_params = action.payload;
    },
    setFanSpacings: (state, action: PayloadAction<IFanSpacings>) => {
      state.fan_spacings = action.payload;
    },
    setFanMotorBaseParams: (
      state,
      action: PayloadAction<{ motor_base: IFanMotorBaseParams }>
    ) => {
      state.fan_motor_base_params = action.payload.motor_base;
    },
    setFanIsolatorsSpringParams: (
      state,
      action: PayloadAction<{ spring_isolator: IFanIsolatorsSpringParams }>
    ) => {
      state.fan_isolators_spring_params = action.payload.spring_isolator;
    },
  },
});

export const {
  setFan,
  setFanParams,
  setFanSpacings,
  setFanMotorBaseParams,
  setFanIsolatorsSpringParams,
} = fanSlice.actions;

export default fanSlice.reducer;
